import { modalDescriptionStyles } from './modal-description.styles'

type THeaderLabelProps = {
  children: string
} & Partial<React.HTMLAttributes<HTMLSpanElement>>

export function ModalDescription({ children, ...rest }: THeaderLabelProps) {
  return (
    <span {...rest} data-testid={rest.id} className={modalDescriptionStyles()}>
      {children}
    </span>
  )
}
